// Simple page-level RBAC utilities

/**
 * Determine whether the given user is allowed to access the page based on page.settings.
 * Rules:
 * - If accessCheck is falsy, allow.
 * - Admins are always allowed.
 * - If accessMembers is empty/missing, deny (safe-by-default when accessCheck enabled).
 * - Allow if any member matches:
 *	- { type: 'user', value: emailOrId } matches user's email or id (string compare)
 *	- { type: 'role', value: roleName } matches 'admin' or any role on the user
 */
export function isUserAllowedOnPage(page, user, isAdmin = false) {
	const accessCheckEnabled = !!page?.settings?.accessCheck;
	if (!accessCheckEnabled) return true;

	if (isAdmin) return true;

	const members = Array.isArray(page?.settings?.accessMembers)
		? page.settings.accessMembers
		: [];
	if (members.length === 0) return false;

	const userId = user?.id != null ? Number(user.id) : null;
	const userRoles = Array.isArray(user?.roles)
		? user.roles.map(r => String(r).toLowerCase())
		: (user?.role ? [String(user.role).toLowerCase()] : []);

	for (const item of members) {
		if (!item || !item.type) continue;
		if (item.type === 'user') {
			const memberId = item.id != null ? Number(item.id) : null;
			if (memberId != null && userId != null && memberId === userId) return true;
		} else if (item.type === 'role') {
			const role = String(item.value ?? '').toLowerCase();
			if (!role) continue;
			if (role === 'admin') return true;
			if (userRoles.includes(role)) return true;
		}
	}

	return false;
}